function arrayMove<T extends object>(arr: T[], fromIndex: number, toIndex: number) {
    console.log('move ' + fromIndex + ' to ' + toIndex);
    const element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
}

export default arrayMove;